<template>
    <div>
        <b-card no-body class="mb-1">
            <b-modal id="upload" title="Luca Dosyası Yükle" no-close-on-esc no-close-on-backdrop>
                <calculate-salary-process-luca-upload-file v-model="uploadObject"></calculate-salary-process-luca-upload-file>
                <template #modal-footer><v-executer :disabled="!uploadObject.File" :loading="loading" text="Yükle" :action="upload"></v-executer></template>
            </b-modal>
    
            <v-table    ref="table"
                        :items-provider="provider"
                        pagination="server"
                        :settings="false"
                        :fields="fields"
                        :initial-load="false">
                            <template #additional-actions>
                                <div class="row">
                                    <div class="col-md-3 mb-1 mb-md-0">
                                        <b-input-group class="input-group-merge v-table-search-input">
                                            <template #prepend>
                                                <b-input-group-text >
                                                    <feather-icon icon="SearchIcon"></feather-icon>
                                                </b-input-group-text>
                                            </template>
                                            <b-form-input v-on:keyup.enter="checkUnsavedAndGetAll" v-model="searchValue" placeholder="Ara..." ></b-form-input>
                                        </b-input-group>
                                    </div>
                                    <div class="col-md-auto mb-1 mb-md-0">
                                        <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                                    </div>
                                    <div class="col-md-auto mb-1 mb-md-0 ml-md-auto">
                                        <b-dropdown text="İşlemler" right variant="primary">
                                            <b-dropdown-item v-on:click="showUploader">
                                                <feather-icon icon="UploadIcon" class="mr-50"></feather-icon>
                                                Dosya Yükle
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </template>
                    </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BInputGroupText, BInputGroup, BFormInput,BDropdown,BDropdownItem } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import CalculateSalaryProcessLucaUploadFile from './CalculateSalaryProcessLucaUploadFile.vue'
import Additional from '@/utilities/additional'

export default {
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:()=>({})
        },
    },
    components:{
        CalculateSalaryProcessLucaUploadFile,
        BCard,
        BInputGroupText, 
        BInputGroup, 
        BFormInput,
        BDropdown,
        BDropdownItem
    },
    data(){
        return {
            uploadObject:{
                Month:null,
                Year:null,
                File:null,
                Kesinti:false
            },
            fields:[
                {name:'Sicil No', key:'RegistrationCode',thClass:'w-16'},
                {name:'Personel', key:'FullName',thClass:'w-21',tdClass:'text-nowrap'},
                {name:"Şube Bilgisi",component:true,componentOptions:{name:"csp-luca-bordro-branch/CSPLucaBordroBranch"}, thClass:'w-39',tdClass:'p-0'},
                {name:'Net',key:'NetStr',thClass:'w-12 vt-th-text-right',tdClass:'text-right'},
                {name:'Brüt',key:'BrutStr',thClass:'w-12 vt-th-text-right',tdClass:'text-right'},
            ],
            loading:false, 
            searchValue:null,
        }
    },
    methods:{
        clear(){
            this.uploadObject.Month = null
            this.uploadObject.Year = null
            this.uploadObject.File = null
        },
        showUploader(){
            this.clear()
            this.$showModal('upload')
        },
        provider(data){
            return EmployeeOperationsApi.LucaBordro.Table({
                ...this.filter,
                PaginateRequest:{
                    ...data,
                    QueryParam: this.searchValue || null,
                }
            })
        },
        async upload(){
            this.loading = true
            let formData = await Additional.ToFormData({
                ...this.uploadObject,
                Filter:{
                    ...this.filter,
                    PaginateRequest:{
                        QueryParam: this.searchValue || null,
                    }
                },
            },['File'])
            EmployeeOperationsApi.LucaBordro.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    },
}
</script>